<template>
    <div class="header vh-box-shadow-small">
        <div class="header-nav">

            <!-- THIS IS LEFT ICON BARS -->
            <div class="header-icon-bar">
                <a href="#"
                    @click="toggleSidebar()">
                    <i class="fas fa-bars"></i>
                </a>
            </div>
            
            

            <!-- THIS IS RIGHT CLOCK, AVATAR, NAME -->
            <div class="header-menu-nav">

                <div>
                <h1 class="vh-margin-remove-vertical">
                    <vh-clock />
                </h1>
            </div>

                <account-component/>

            </div>

        </div>

        <logout-modal />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import AccountComponent from './content/account';

import LogoutModal from '../components/modals/logout';

export default
{
    name: 'Header',

    components:
    {
        AccountComponent,

        LogoutModal,
    },

    data()
    {
        return {
            logoutModal: false,
        };
    },

    computed:
    {
        ...mapGetters({
            accessUser: 'auth/accessUser',
            isLoading: 'auth/isLoading',
        }),

        appName()
        {
            return process.env.VUE_APP_TITLE;
        },

        isDevelopment()
        {
            return process.env.VUE_APP_ENVIRONMENT === 'development';
        },

        appVersion()
        {
            return process.env.VUE_APP_VERSION;
        },

        isCompany()
        {
            return this.accessUser.account_type.id == 2;
        },
    },

    methods:
    {
        ...mapActions({
            toggleSidebar: 'layout/toggleSidebar',
        }),

        toggleModal(name, bool)
        {
            this[`${name}Modal`] = bool;
        },
    },
};
</script>
